module.exports = __webpack_public_path__ + "static/media/fees.6bcd09f2.svg";